import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    name: "companyAudit",
    path: '/companyAudit',
    component: () => import('@/views/bus/shop/companyAudit'),
    hidden: true
  },
  {
    name: "goShop",
    path: '/goShop',
    component: () => import('@/views/bus/shop/goShop'),
    hidden: true
  },
  {
    name: 'adminAudit',
    path: '/adminAudit',
    component: () => import('@/views/bus/shop/adminAudit'),
    hidden: true
  },
  {
    name: 'logTempLate',
    path: '/logTempLate',
    component: () => import('@/views/bus/logTemplate/index'),
    hidden: true
  },
  {
    name:'shopAudit',
    path: '/shopAudit',
    component: () => import('@/views/bus/shop/shopAudit'),
    hidden: true
  },
  {
    name:'online',
    path: '/online',
    component: () => import('@/views/bus/shop/onlineContract'),
    hidden: true
  },
  {
    name:'shopNotice',
    path: '/shopNotice',
    component: () => import('@/views/bus/shop/shopNotice'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: 'Dashboard', icon: 'dashboard' }
    }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  base:process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_HEAD
      : '/',
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
